export default __webpack_public_path__ + "static/media/ic_book-queue.1b00c9db.svg";